"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AuditItem = /** @class */ (function () {
    function AuditItem(_categoryId, _instanceId, _modifiedDate, _operationType, _actionName, _userId, _data, _context) {
        this._categoryId = _categoryId;
        this._instanceId = _instanceId;
        this._modifiedDate = _modifiedDate;
        this._operationType = _operationType;
        this._actionName = _actionName;
        this._userId = _userId;
        this._data = _data;
        this._context = _context;
    }
    Object.defineProperty(AuditItem.prototype, "categoryId", {
        get: function () {
            return this._categoryId;
        },
        set: function (value) {
            this._categoryId = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuditItem.prototype, "instanceId", {
        get: function () {
            return this._instanceId;
        },
        set: function (value) {
            this._instanceId = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuditItem.prototype, "modifiedDate", {
        get: function () {
            return this._modifiedDate;
        },
        set: function (value) {
            this._modifiedDate = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuditItem.prototype, "operationType", {
        get: function () {
            return this._operationType;
        },
        set: function (value) {
            this._operationType = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuditItem.prototype, "actionName", {
        get: function () {
            return this._actionName;
        },
        set: function (value) {
            this._actionName = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuditItem.prototype, "userId", {
        get: function () {
            return this._userId;
        },
        set: function (value) {
            this._userId = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuditItem.prototype, "data", {
        get: function () {
            return this._data;
        },
        set: function (value) {
            this._data = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuditItem.prototype, "context", {
        get: function () {
            return this._context;
        },
        set: function (value) {
            this._context = value;
        },
        enumerable: true,
        configurable: true
    });
    AuditItem.asEntries = function (jsonData) {
        return jsonData.map(AuditItem.asEntry);
    };
    AuditItem.asEntry = function (jsonData) {
        return new AuditItem(jsonData['categoryId'], jsonData['instanceId'], jsonData['modifiedDate'], jsonData['operationType'], jsonData['actionName'], jsonData['userId'], jsonData['data'], jsonData['context']);
    };
    return AuditItem;
}());
exports.AuditItem = AuditItem;
//# sourceMappingURL=audit-item.model.js.map